export const filesQueryKeys = {
  all: ['files'] as const,
  list: () => [...filesQueryKeys.all, 'list'] as const,
  detail: (id: string) => [...filesQueryKeys.all, id] as const,
};
